import { useState } from "react";
import { setApiUrl, getApiUrl } from "../api/client.js";

interface Props {
  onSave: () => void;
}

export function ApiKeySetup({ onSave }: Props) {
  const [url, setUrl] = useState(getApiUrl);

  function handleSave() {
    if (!url.trim()) return;
    setApiUrl(url.trim());
    onSave();
  }

  return (
    <div className="setup-screen">
      <div style={{ width: "100%", maxWidth: 360, textAlign: "center" }}>
        <div className="setup-logo">A</div>
        <h1 className="setup-title">Alkio</h1>
        <p className="setup-subtitle">Operator Dashboard</p>

        <div className="setup-form">
          <label>
            API URL
            <input
              type="url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://api.example.com"
            />
          </label>
          <button
            className="setup-btn"
            onClick={handleSave}
            disabled={!url.trim()}
          >
            Connect
          </button>
        </div>
        <p style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 16 }}>
          You will be redirected to Google for authentication.
        </p>
      </div>
    </div>
  );
}
